import { render, staticRenderFns } from "./TotalAmount.vue?vue&type=template&id=cab58762&scoped=true"
import script from "./TotalAmount.vue?vue&type=script&lang=js"
export * from "./TotalAmount.vue?vue&type=script&lang=js"
import style0 from "./TotalAmount.vue?vue&type=style&index=0&id=cab58762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab58762",
  null
  
)

export default component.exports